import React, { useState, useEffect } from "react";
import styles from "./ERPTable.module.css";
import Pagination from "./Pagination";

const ERPDataTable = () => {
  const headers = [
    "Asset ID",
    "Dep Rate",
    "Business Area",
    "Block of Asset",
    "Capitalized On",
    "Deactivated On",
    "Book Value of Deletion",
    "Opening Gross Block",
    "Opening Accumulated Depreciation",
    "Terminal Value of Asset",
    "Opening Book Value",
    "Acquisition Cost for Current Year Additions",
    "Depreciation Charge for the Period",
    "Deletion Gross Block",
    "Deletion Depreciation",
  ];

  const allData = Array(150).fill({
    assetId: "Data",
    depRate: "234567890",
    businessArea: "4567890",
    blockOfAsset: "LucyMcFarlane",
    capitalizedOn: "22344678",
    deactivatedOn: "23 Dec 2025",
    bookValueDeletion: "Traunt Adam",
    openingGrossBlock: "INR",
    openingAccDepreciation: "7 Jun 2025",
    terminalValue: "Data",
    openingBookValue: "37,123.30",
    acquisitionCost: "345678",
    depreciationCharge: "37128.30",
    deletionGrossBlock: "2,312.70",
    deletionDepreciation: "0",
  });

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [currentData, setCurrentData] = useState([]);

  const totalPages = Math.ceil(allData.length / rowsPerPage);

  useEffect(() => {
    const startIndex = (currentPage - 1) * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    setCurrentData(allData.slice(startIndex, endIndex));
  }, [currentPage, rowsPerPage]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.tableContainer}>
        <div className={styles.tableWrapper}>
          <table className={styles.table}>
            <thead>
              <tr>
                {headers.map((header, index) => (
                  <th key={index} className={styles.tableHeader}>
                    {header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {currentData.map((row, index) => (
                <tr key={index} className={styles.tableRow}>
                  <td className={styles.tableCell}>{row.assetId}</td>
                  <td className={styles.tableCell}>{row.depRate}</td>
                  <td className={styles.tableCell}>{row.businessArea}</td>
                  <td className={styles.tableCell}>{row.blockOfAsset}</td>
                  <td className={styles.tableCell}>{row.capitalizedOn}</td>
                  <td className={styles.tableCell}>{row.deactivatedOn}</td>
                  <td className={styles.tableCell}>{row.bookValueDeletion}</td>
                  <td className={styles.tableCell}>{row.openingGrossBlock}</td>
                  <td className={styles.tableCell}>
                    {row.openingAccDepreciation}
                  </td>
                  <td className={styles.tableCell}>{row.terminalValue}</td>
                  <td className={styles.tableCell}>{row.openingBookValue}</td>
                  <td className={styles.tableCell}>{row.acquisitionCost}</td>
                  <td className={styles.tableCell}>{row.depreciationCharge}</td>
                  <td className={styles.tableCell}>{row.deletionGrossBlock}</td>
                  <td className={styles.tableCell}>
                    {row.deletionDepreciation}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className={styles.paginationWrapper}>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          rowsPerPage={rowsPerPage}
          onPageChange={setCurrentPage}
          onRowsPerPageChange={(rows) => {
            setRowsPerPage(rows);
            setCurrentPage(1);
          }}
        />
      </div>
    </div>
  );
};

export default ERPDataTable;
